<main class="consent-page">
    <section class="consent-card"
             [attr.aria-busy]="!consent && !error">
        <img src="/content/shell/images/adapt-lumia-logo.svg"
             alt="adapt Lumia"
             width="180"
             class="brand" />

        @if (error) {
            <h1>Unable to connect</h1>
            <p role="alert">{{ error }}</p>
        } @else if (consent) {
            <p class="eyebrow">APP CONNECTION</p>
            <h1>Connect {{ consent.AppName }}?</h1>
            <p class="intro">This app is requesting access to your adapt Lumia account.</p>
            <div class="account"><i class="fal fa-user-circle"
                   aria-hidden="true"></i> {{ consent.Account }}</div>

            <div class="permissions">
                <h2>By allowing access, this app can:</h2>
                <div class="permission">
                    <i class="fal fa-folder-open"
                       aria-hidden="true"></i>
                    <div><strong>Access your Lumia data</strong>
                        <p>Use the information and tools available to your account, within your existing permissions.</p>
                    </div>
                </div>
                @if (consent.OfflineAccess) {
                    <div class="permission">
                        <i class="fal fa-clock"
                           aria-hidden="true"></i>
                        <div><strong>Stay connected</strong>
                            <p>Continue accessing your account when you're not actively using Lumia, until access expires or you revoke it.
                            </p>
                        </div>
                    </div>
                }
            </div>

            <div class="connection-details">
                <span>Connecting to</span><strong>{{ consent.CallbackHost }}</strong>
                <details>
                    <summary>App identifier</summary>
                    <p>{{ consent.ClientId }}</p>
                </details>
            </div>
            <p class="reassurance">Only connect apps you trust. You can revoke this app's access from your account settings.</p>
            <div class="actions">
                <button type="button"
                        class="btn btn-outline-secondary"
                        [disabled]="submitting"
                        (click)="submit(false)"
                        data-test="mcp-consent-cancel">Cancel</button>
                <button type="button"
                        class="btn btn-primary"
                        [disabled]="submitting"
                        (click)="submit(true)"
                        data-test="mcp-consent-allow">{{ submitting ? "Returning to app…" : "Allow access" }}</button>
            </div>
        } @else {
            <h1>Review app access</h1>
            <p role="status">Loading the access request…</p>
        }
    </section>
    <p class="consent-footer"><i class="fal fa-lock-alt"
           aria-hidden="true"></i> Your password is never shared with the app.</p>
</main>
